/* The Hollow Harvest · il guscio del negozio (C6, 20 ott 2026)
   1. L'avviso affisso: la candela si consuma con l'ottobre (--cera), dopo il 31 ottobre alle 23:59 ora italiana
      il testo di prima lascia il posto a quello di dopo (il server lo fa gia' con 'now'; qui per le pagine in cache).
      La fiamma dorme quando l'avviso esce dallo schermo.
   2. [data-hhr-in]: aggiunge is-in quando l'elemento arriva sullo schermo (entrate delle pagine del negozio).
   3. [data-hhr-scade]: le righe con la data vera dei prezzi (scheda prodotto) spariscono dopo la data.
   4-6. La barra d'acquisto a telefono, l'indice delle voci a computer, il sigillo che si ribatte al tocco.
   Caricato due volte se avviso e intestazione ci sono tutti e due (snippets/hhr-fogli): la guardia lo fa girare una. */
(function () {
  if (window.hhrGuscio) return;
  window.hhrGuscio = true;
  var d = document, html = d.documentElement;

  function avviso() {
    var el = d.querySelector('[data-hhr-avviso]');
    if (!el) return;
    var scade = parseInt(el.getAttribute('data-scade'), 10) * 1000;
    var ora = Date.now();
    var resta = Math.max(0, scade - ora);
    var cera = Math.min(1, Math.max(0.12, resta / (30 * 864e5)));
    var fiamma = el.querySelector('.hhr-fiamma');
    if (fiamma) fiamma.style.setProperty('--cera', cera.toFixed(3));
    if (ora > scade) {
      var prima = el.querySelector('[data-hhr-prima]'), dopo = el.querySelector('[data-hhr-dopo]');
      if (prima) prima.hidden = true;
      if (dopo) dopo.hidden = false;
    }
    if (fiamma && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (voci) {
        voci.forEach(function (v) { fiamma.classList.toggle('dorme', !v.isIntersecting); });
      }).observe(el);
    }
  }

  function entrate() {
    var nodi = d.querySelectorAll('[data-hhr-in]');
    /* arrivato tardi: la rete di sicurezza del CSS ha gia' rivelato tutto, non si torna indietro */
    if (!('IntersectionObserver' in window) || !html.classList.contains('hhr-mosso') || performance.now() > 2800) {
      for (var i = 0; i < nodi.length; i++) nodi[i].classList.add('is-in');
      return;
    }
    html.classList.add('hhr-vivo');
    var io = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        if (v.isIntersecting) { v.target.classList.add('is-in'); io.unobserve(v.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    for (var j = 0; j < nodi.length; j++) io.observe(nodi[j]);
    window.hhrEntrate = function (radice) {
      var nuovi = (radice || d).querySelectorAll('[data-hhr-in]:not(.is-in)');
      for (var k = 0; k < nuovi.length; k++) io.observe(nuovi[k]);
    };
  }

  function scadute() {
    var righe = d.querySelectorAll('[data-hhr-scade]');
    for (var i = 0; i < righe.length; i++) {
      if (Date.now() > parseInt(righe[i].getAttribute('data-hhr-scade'), 10) * 1000) righe[i].hidden = true;
    }
  }

  /* 4. la barra d'acquisto a telefono: fuori quando il bottone del cartellino o il piede sono sullo schermo (un ember) */
  function barra() {
    var b = d.querySelector('[data-hhr-barra]');
    if (!b || !('IntersectionObserver' in window)) return;
    var guardati = [d.querySelector('.hhr-cartellino .product-form__buttons'), d.querySelector('.hhr-piede')];
    var visti = [];
    var io = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) { visti[guardati.indexOf(v.target)] = v.isIntersecting; });
      b.classList.toggle('is-via', visti[0] !== false || visti[1] === true);
    }, { rootMargin: '0px 0px -84px 0px' });
    for (var i = 0; i < guardati.length; i++) if (guardati[i]) io.observe(guardati[i]);
  }

  /* 5. l'indice delle voci (computer): la voce in lettura prende il chiodo */
  function indice() {
    var nav = d.querySelector('[data-hhr-indice]');
    if (!nav || !('IntersectionObserver' in window)) return;
    var voci = d.querySelectorAll('.hhr-desc-h[id]');
    var segna = function (id) {
      var link = nav.querySelectorAll('.hhr-indice__a');
      for (var i = 0; i < link.length; i++) {
        if (link[i].getAttribute('href') === '#' + id) link[i].setAttribute('aria-current', 'location');
        else link[i].removeAttribute('aria-current');
      }
    };
    var io = new IntersectionObserver(function (vv) {
      vv.forEach(function (v) { if (v.isIntersecting) segna(v.target.id); });
    }, { rootMargin: '-10% 0px -55% 0px' });
    for (var j = 0; j < voci.length; j++) io.observe(voci[j]);
  }

  /* 6. il sigillo del carrello e della chiusa del registro si ribatte al tocco, ogni volta un po' storto */
  function timbro() {
    d.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.hhr-q-timbro, .hhr-chiusa') : null;
      if (!t) return;
      var a = !t.classList.contains('ribatte-a');
      t.classList.toggle('ribatte-a', a);
      t.classList.toggle('ribatte-b', !a);
    });
  }

  function via() {
    try { avviso(); } catch (e) {}
    try { scadute(); } catch (e) {}
    try { barra(); } catch (e) {}
    try { indice(); } catch (e) {}
    try { timbro(); } catch (e) {}
    try { entrate(); } catch (e) {
      var n = d.querySelectorAll('[data-hhr-in]');
      for (var i = 0; i < n.length; i++) n[i].classList.add('is-in');
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', via); else via();
})();
